import router from '@/router';

const RouterService = {
    install(Vue) {
        Vue.prototype.$routerService = {
            goTo: (route, params = null) => {
                router.push({name: route, params: params}).catch(() => {});
            },
            watchLink(property) {
                window.addEventListener('click', (event) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (event.target.dataset.hasOwnProperty(property)) {
                        router.push({name: property}).catch(() => {});
                    }
                })
            }
        }
    }
}

export default (RouterService);
